// extracted by mini-css-extract-plugin
module.exports = {"mdTitle":"BannerContent_mdTitle__eM6nY"};